import { render, staticRenderFns } from "./AdminMergeDialog.vue?vue&type=template&id=16010d47&scoped=true&"
import script from "./AdminMergeDialog.vue?vue&type=script&lang=js&"
export * from "./AdminMergeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminMergeDialog.vue?vue&type=style&index=0&id=16010d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16010d47",
  null
  
)

export default component.exports